module.exports = __webpack_public_path__ + "eec93a8b3e5179d1e7c0a3ffe3caa7d6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-25.png
// module id = 2229
// module chunks = 0